import React, {CSSProperties, ReactElement} from 'react';

import classNames from 'classnames';
import {observer} from 'mobx-react';

type ValidationFunction = () => void;
interface SlideSwiperProps {
    active?: boolean;
    style?: CSSProperties;
    automaticNextSlide: () => void;
    children: ReactElement<Record<string, string | boolean | number | ValidationFunction>>;
    className?: string;
}

const SlideSwiper: React.FC<SlideSwiperProps> = ({active, style, children, className, automaticNextSlide}) => {
    const onClickMemoized = React.useCallback(
        (e: React.MouseEvent<HTMLElement>) => {
            const {validation} = children?.props;
            const target = e.target as HTMLElement;
            const parent = target.parentNode as HTMLElement;

            const isButton = target.tagName === 'BUTTON' || parent.tagName === 'BUTTON';

            if (typeof validation === 'function' && isButton) {
                automaticNextSlide && automaticNextSlide();
            }
        },
        [children?.props.validation, automaticNextSlide],
    );

    return (
        <div style={style} className={classNames(className)}>
            <div
                style={{display: !active ? 'none' : null}}
                data-testid={active ? 'activeSlide' : 'inactiveSlide'}
                className={active ? 'activeSlide' : null}
                onClick={onClickMemoized}
            >
                {children}
            </div>
        </div>
    );
};

export default observer(SlideSwiper);
